import { useEffect } from 'react';

/** The tab title before anyone signs in (public/index.html). */
export const DEFAULT_DOCUMENT_TITLE = 'Ardealy - Backoffice';

/**
 * Sets the browser tab title while the caller is mounted, and puts the default
 * back when it unmounts — so a signed-out vendor's name never stays in the tab
 * for whoever signs in next. Nothing is set until `title` is known.
 */
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  useEffect(
    () => () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    },
    [],
  );
}
